export const PURCHASE_OPERATOR_TOKEN = "PURCHASE_OPERATOR_TOKEN";
export const PURCHASE_OPERATOR_TOKEN_SUCCESS =
  "PURCHASE_OPERATOR_TOKEN_SUCCESS";
export const PURCHASE_OPERATOR_TOKEN_FAILURE =
  "PURCHASE_OPERATOR_TOKEN_FAILURE";
export const PURCHASE_OPERATOR_TOKEN_STARTED =
  "PURCHASE_OPERATOR_TOKEN_STARTED";
export const GET_PURCHASE_OPERATOR_TOKEN_DATA =
  "GET_PURCHASE_OPERATOR_TOKEN_DATA";
export const APPEND_OPERATOR_PURCHASE_DETAILS =
  "APPEND_OPERATOR_PURCHASE_DETAILS";
